function i(n) {
  return n.options !== void 0;
}
function r(n) {
  return n.reduce((e, t) => i(t) ? [...e, ...t.options] : [...e, t], []);
}
export {
  r as flattenOptions,
  i as isOptionsGroup
};
